<template>
	<div class="partial-container partial-notification minified-sidebar" :class="{'auth-page': isAuthPage}">
		<div v-for="(notification, index) in notifications" :key="index" class="notification-item" :class="[`n-type--${notification.type}`]">
			<div class="icon">
				<fa v-if="notification.type === 'success'" class="fa-icon" :icon="['fas', 'check']" />
				<fa v-if="notification.type === 'notice'" class="fa-icon" :icon="['fas', 'info']" />
				<fa v-if="notification.type === 'warning'" class="fa-icon" :icon="['fas', 'exclamation']" />
				<fa v-if="notification.type === 'error'" class="fa-icon" :icon="['fas', 'times']" />
			</div>
			<div class="message">
				<p class="text" v-text="notification.message"></p>
				<p v-if="notification.repeated > 0" class="text repeated" v-text="`x${notification.repeated}`"></p>
			</div>
		</div>
	</div>
</template>

<script lang="ts">
	import { Options, Vue } from 'vue-class-component';

	@Options({
		name: 'Notification',
	})
	export default class NotificationPartial extends Vue {

		public get notifications(): Array<any> {
			return this.$store.state.notification.notifications;
		}

		public get isAuthPage(): boolean {
			if (this.$route.path.indexOf('/auth/') > -1) return true;
			return false;
		}
	}
</script>

<style lang="scss" scoped>
	@import '../assets/styles/base';
	@import '../assets/styles/partials/notification';

	.message p {
		white-space: break-spaces;
	}
</style>
